<script setup>
import { useGarantiaStore } from "@/store/garantiaStore";
import { onMounted, ref, nextTick } from "vue";
import { Modal } from "bootstrap";
import { alertConfirmar } from "@/utils/alerts";

import CargaGarantiaModal from "./CargaGarantiaModal/CargaGarantiaModal.vue";
import CargaGarantiaWarningModal from "./CargaGarantiaModal/CargaGarantiaWarningModal.vue";

import BadgesResumen from "./UserCredito/BadgesResumen.vue";
import TablaMovimientos from "./UserCredito/TablaMovimientos.vue";
import TablaOfertasVigentes from "./UserCredito/TablaOfertasVigentes.vue";
import AccionesFinales from "./UserCredito/AccionesFinales.vue";
import InfoGarantias from "./UserCredito/InfoGarantias.vue";
import PedidoDevolucionModal from "./UserCredito/PedidoDevolucionModal.vue";

const garantiasStore = useGarantiaStore();

const cargaGarantiaModal = ref(null);
const pedirDevolucionModal = ref(null);
const cargaGarantiaModalWarning = ref(null);

onMounted(async () => {
  await garantiasStore.obtenerResumenGarantia();
  garantiasStore.obtenerMisMovimientosGarantias();
  garantiasStore.getMediosDePago();
  garantiasStore.getMediosDePagoDestino();
  garantiasStore.getMonedas();

  cargaGarantiaModal.value = new Modal(
    document.getElementById("carga-garantia-modal"),
    { backdrop: "static", keyboard: false }
  );

  await nextTick();

  cargaGarantiaModalWarning.value = new Modal(
    document.getElementById("carga-garantia-modal-warning"),
    { backdrop: "static", keyboard: false }
  );

  pedirDevolucionModal.value = new Modal(
    document.getElementById("pedido-devolucion-modal"),
    { backdrop: "static", keyboard: false }
  );
});

function cargarGarantia() {
  cargaGarantiaModalWarning.value?.show();
}

function cargarGarantiaConfirmada() {
  cargaGarantiaModalWarning.value?.hide();
  cargaGarantiaModal.value?.show();
}

function abrirPedirDevolucionModal() {
  pedirDevolucionModal.value?.show();
}

function closeCargarGarantias() {
  cargaGarantiaModal.value?.hide();
  alertConfirmar("Garantía enviada");
}

function closePedirDevolucionModal() {
  pedirDevolucionModal.value?.hide();
}

async function confirmarDevolucion() {}
</script>

<template>
  <div class="user-credito container mx-auto mt-5">
    <div class="row g-3">
      <div class="col-md-12">
        <div class="card p-4 shadow-none w-100 h-100">
          <h5 class="titulo-garantias">
            Garantías y créditos
            <span class="titulo-subasta">
              <img class="me-1" src="@/assets/img/icons/click21.svg" alt="">
              Subasta
            </span>
          </h5>

          <BadgesResumen :garantiasStore="garantiasStore" />

          <AccionesFinales
            :garantiasStore="garantiasStore"
            @informar-garantia="cargarGarantia"
            @pedir-devolucion="abrirPedirDevolucionModal"
          />
          <TablaMovimientos
            class="mt-3 pt-4"
            :garantiasStore="garantiasStore"
          />
          <TablaOfertasVigentes class="mt-3" :garantiasStore="garantiasStore" />
        </div>
      </div>

      <div class="col-md-12">
        <div class="shadow-none w-100 h-100">
          <InfoGarantias />
        </div>
      </div>
    </div>
  </div>

  <CargaGarantiaModal
    @closeCargarGarantias="closeCargarGarantias"
    :garantiasStore="garantiasStore"
  />
   <CargaGarantiaWarningModal
    @cargaGarantiaConfirmada = "cargarGarantiaConfirmada"
  />

  <PedidoDevolucionModal
    ref="modalDevolucionRef"
    :garantiasStore="garantiasStore"
    @confirm="confirmarDevolucion"
    @close-pedir-devolucion="closePedirDevolucionModal"
  />
</template>

<style scoped>
.table-clean th,
.table-clean td {
  vertical-align: middle;
  white-space: nowrap;
}

.table-clean thead th {
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  font-weight: 600;
}

.table-clean tbody tr + tr {
  border-top: 1px solid #f1f3f5;
}

.page-title {
  color: #000;
  font-family: Roboto;
  font-size: 1.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.titulo-garantias {
  font-family: Roboto;
  font-size: 30px;
  font-weight: 700;
  color: #000;
  display: flex;
  align-items: center;
  gap: 6px;
}

.titulo-subasta {
  font-family: Roboto;
  font-size: 30px;
  font-weight: 500;
  color: #006C4C;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.titulo-icono {
  width: 21px;
  height: 21px;
  flex-shrink: 0;
}

</style>
